'use client';

// Read hook for pending invites. Mirrors useTeamData shape.

import { useCallback, useEffect, useState } from "react";
import { useTeam, errText } from "../internals";

export const useInvites = () => {
  const { storage } = useTeam();
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const list = await storage.listInvites();
      setInvites(list || []);
    } catch (e) {
      setError(errText(e));
    } finally {
      setLoading(false);
    }
  }, [storage]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { invites, loading, error, refresh };
};
